/**
 * Reloads the Available Products page when the workspace changes, so the
 * server re-renders the CURRENT-vs-NEW plan comparison for the chosen
 * workspace. No-op on pages without the selector.
 */
export function initWorkspaceSelector() {
  const select = document.getElementById('available-products-workspace-select');

  if (!select?.form) {
    return;
  }

  select.addEventListener('change', () => {
    select.form.requestSubmit();
  });
}
